export default "__VITE_ASSET__ChxgAUEI__"